 const DocumentsEnum = [];

export default DocumentsEnum;




// WEBPACK FOOTER //
// ./src/enum/documents.js